import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { AccessKey } from 'src/features/accessKey/utils/types';
import { AccessKeyFormSchemaValues } from 'src/features/accessKey/utils/formSchema';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/visitors/access-key/:id/`;

type MutationFnType = typeof mutationFn;

interface DTO extends AccessKeyFormSchemaValues {
    id: string;
    parkingId: string;
}
const mutationFn = ({ id,parkingId, ...data }: DTO): Promise<AccessKey> => {
    return axios.put(formatResourcePath(RESOURCE, { id, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateAccessKey };
